import { render, staticRenderFns } from "./VideoParser.vue?vue&type=template&id=4add8bf2"
import script from "./VideoParser.vue?vue&type=script&lang=js"
export * from "./VideoParser.vue?vue&type=script&lang=js"
import style0 from "./VideoParser.vue?vue&type=style&index=0&id=4add8bf2&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports